import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { GenericsService } from './generics.service';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  public static enums:any[];
  constructor(private generics:GenericsService) { }

  public static alerta(mensagem:string, tipo?:string) {
    //eval("M.toast({html: '" + mensagem + "'})");

    let typeMessage:any = "";

    switch(tipo) {
      case "erro":
          typeMessage = "error";
          break;
      case "atencao":
          typeMessage = "warning";
          break;
      case "informacao":
          typeMessage = "info";
          break;
      case "questionamento":
        typeMessage = "question";
        break;
      default:
        typeMessage = "success";
        break;
    }

    Toast.fire({
      timer: (typeMessage !== "success" ? 7000 : 2000),
      type: typeMessage,
      title: mensagem
    });
  }

  public static confirmacao(titulo, texto) {
    return Toast.fire({
      title: titulo,
      text: texto,
      timer: 10000,
      type: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    });
  }

  public static setSelect() {
    eval("window.M.FormSelect.init(document.querySelectorAll('.row select'), {});");
  }

  public static setDate() {
    eval("window.M.Datepicker.init(document.querySelectorAll('.row .datepicker'), { " +
         "selectMonths: true," +
         "selectYears: 100," +
         "showAnim: 'scale',"+
         "labelMonthSelect: 'Selecione o mês'," +
         "labelYearSelect: 'Selecione o ano'," +
         "labelMonthNext: 'Proximo Mês', " +
         "labelMonthPrev: 'Mês Anterior', " +
         "labelMonthSelect: 'Selecionar Mês', " +
         "labelYearSelect: 'Selecionar Ano', " +
         "showDaysInNextAndPreviousMonths: 'true'," +
         "format: 'dd/mm/yyyy', " +
         "formatSubmit: 'dd/mm/yyyy', " +
         "changeYear: true," +
         "container: 'body'," +
         "i18n: { " +
           "months: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro']," +
           "monthsFull: [ 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro' ]," +
           "monthsShort: ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'], " +
           "weekdays: ['Domingo','Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']," +
           "weekdaysShort: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'],  " +
           "weekdaysAbbrev:	['D','S','T','Q','Q','S','S'], " +
           "done: 'Ok'," +
           "cancel: 'Cancelar', " +
           "clear: 'Limpar', " +
           "close: 'X'," +
           "twelveHour: true, " +
           "defaultTime: true" +
         " }, " +
         "onSelect: function(e) { var dt = new Date(e); document.getElementById(this.$el[0].id).value = e.toLocaleDateString(); if (document.querySelector('lbl'+this.$el[0].id) != null) { document.getElementById('lbl'+this.$el[0].id).className.replace('active', ''); document.getElementById('lbl'+this.$el[0].id).className += ' active'; console.log('lbl'+this.$el[0].id); }  }});");
  }

  public static setEnums(enums:any) {
    this.enums = Object(enums);
    localStorage.setItem('enums', JSON.stringify(enums));
    console.log(this.enums);
  }

  public static getEnums(key?:string) {
    if (this.enums == undefined || this.enums == null) {
      let en = localStorage.getItem('enums');
      if (en !== undefined || en !== null)
        this.enums = JSON.parse(en);
    }

    if (key !== undefined && key !== '') {
      let enums = {};
      let obj = UtilsService.enums.find((obj) => obj.tipo == key);

      if (obj["valores"] !== undefined)
        for (let idx = 0; idx < obj["valores"].length; idx++) {
          enums[obj["valores"][idx]["valor"]] = obj["valores"][idx]["descricao"];
        }
      console.log(enums);
      return enums;
    } else return this.enums;
  }

  public static compareDate(date1: Date, date2: Date): number
  {
    // With Date object we can compare dates them using the >, <, <= or >=.
    // The ==, !=, ===, and !== operators require to use date.getTime(),
    // so we need to create a new instance of Date with 'new Date()'
    let d1 = new Date(date1); 
    d1.setHours(0,0,0,0);
    let d2 = new Date(date2);
    d2.setHours(0,0,0,0);
    
    console.log("Timestamp: ", d1, d2);
    // Check if the dates are equal
    if (d1.getTime() == d2.getTime()) return 0;
    else 
  
    // Check if the first is greater than second
    if (d1 > d2) return 1;
    else 

    // Check if the first is less than second
    if (d1 < d2) return -1;
  }

}